export const RESIGNATION_STATUS = Object.freeze({
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
});

export const RESIGNATION_STATUS_OPTIONS = Object.freeze([
  { key: RESIGNATION_STATUS.PENDING, label: '待审批' },
  { key: RESIGNATION_STATUS.APPROVED, label: '已通过' },
  { key: RESIGNATION_STATUS.REJECTED, label: '已驳回' },
]);

export const RESIGNATION_STATUS_LABELS = Object.freeze(
  RESIGNATION_STATUS_OPTIONS.reduce((labels, option) => ({
    ...labels,
    [option.key]: option.label,
  }), {}),
);

export const RESIGNATION_PAGE_SIZE = 10;

export const RESIGNATION_APPLICATION_FIELDS = Object.freeze([
  'requestedResignDate',
  'requestedReason',
  'remark',
]);

/**
 * @typedef {Object} ResignationApplicationCreateMO
 * @property {number|string} requestedResignDate
 * @property {string} requestedReason
 * @property {string=} remark
 */

/**
 * @typedef {Object} ResignationApplicationPageMO
 * @property {'PENDING'|'APPROVED'|'REJECTED'} status
 * @property {number} pageNumber
 * @property {number} pageSize
 */

/**
 * @typedef {Object} ResignationApplication
 * @property {string|number} id
 * @property {'PENDING'|'APPROVED'|'REJECTED'} status
 * @property {number|string} requestedResignDate
 * @property {string} requestedReason
 * @property {string} remark
 * @property {number|string=} createdDate
 * @property {number|string=} resignDate
 * @property {string=} reason
 * @property {string=} rejectReason
 */

export default RESIGNATION_STATUS;
